export default "<div class=\"ground\">\n  <div class=\"building\">\n    <img src=\"./assets/control-center.svg\" alt=\"\" />\n  </div>\n</div>\n";